import { Component, input, model } from '@angular/core';
import { Checkbox } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'ct-shared-use-for-training-checkbox',
  imports: [Checkbox, FormsModule],
  template: `
    <div class="mt-3 flex gap-3">
      <p-checkbox
        [binary]="true"
        [disabled]="disabled()"
        [(ngModel)]="isTicked"
        inputId="useExtractedDataForTraining" />
      <label for="useExtractedDataForTraining">Für BuildSimple Training nutzen</label>
    </div>
  `,
})
export class UseForTrainingCheckboxComponent {
  readonly isTicked = model.required<boolean>();
  readonly disabled = input.required<boolean>();
}
